import { toast } from "@/utils/appToast";
import axios from "axios";
import type { User, WorkerProfile } from "@/types/userTypes";
import { backendCall } from "@/shared/services/backendService";
import { FilterI, StorageI } from "@/types/interfaces";
import { GetLanguage, GetStorage, SetStorage } from "@/shared/services/credentialsService";
import { getBackendCallErrorMessage } from "@/utils/backendErrorMessage";
import type { MetaConversionPayload } from "@/utils/metaPixel";
import type {
  InitiateJobPaymentPayload,
  InitiateJobPaymentResponse,
  MyVoucher,
  ProviderVoucherPreview,
  ReleasePaymentResponse,
} from "@/types/jobPaymentTypes";

// TODO: Eliminar todos los status !== 200 porque Axios tira error cuando la response no es 200/201/etc. Asique ese manejo se debe hacer en el catch

// @ts-expect-error: Error de tipado en import.meta (no lo encuentra)
const baseURL = import.meta.env.VITE_BACKEND_URL;
// 

const getRequestLang = () => GetLanguage() || "es";
export const api = {
  signIn: async (loginData: { email: string; password: string }) => {
    return backendCall({
      url: "/api/auth/sign-in",
      method: "POST",
      data: loginData,
      contentType: "application/json",
    })
      .then((res) => {
        return res;
        // if (res && res.success) {
        //   // const storageData: StorageI = { data: res.data };
        //   // SetStorage(storageData)
        //   return {
        //     status: "success",
        //     data: res.data,
        //   };
        // } else {
        //   return {
        //     status: "error",
        //     data: {
        //       message: res?.message || (res?.data && res.data.message) || "Unknown error",
        //     },
        //   };
        // }
      })
  },

   resetUnseenMessages: async () => {
    return backendCall({
      url: "/api/users/resetmessagecounter",
      method: "POST",
      contentType: "application/json",
    }).then((res) => {
      return res;
    }).catch((error) => error);
  },

  resetChatUnseenMessages: async (chatId: string) => {
  return backendCall({
    url: "/api/chats/reset-user-counter",
    method: "POST",
    contentType: "application/json",
    data: { chatId }, // send the chatId in the body
  })
    .then((res) => res)
    .catch((error) => error);
},

// api/chat.ts (or wherever you keep your chat APIs)

 getUserChatCounter: async (chatId: string) => {
  return backendCall({
    url: "/api/chats/chat-user-counter", // backend endpoint
    method: "POST",
    contentType: "application/json",
    data: { chatId }, // send chatId in request body
  })
    .then((res) => res)
    .catch((error) => error);
},

  getUnseenMessages: async () => {
  return backendCall({
    url: "/api/users/messagecounter",
    method: "GET",
    contentType: "application/json",
  })
  .then((res) => {
    return res;
  })
  .catch((error) => error);
},


  getMyJobs: async (body) => {
    // const token = localStorage.getItem('token');

    return backendCall({
      url: `/api/job/by-user-type?page=${body.page}&limit=${body.limit}`,
      method: "POST",
      data: body,
      contentType: "application/json",
    })
    .then((res) => {
      return res;
    })
    .catch((error) => error);

    // const { data } = await axios.post(`${baseURL}/api/job/by-user-type`, body, {
    //   headers: {
    //     Authorization: `Bearer ${token}`,
    //   },
    // });
    // return data;
  }
  ,
  signUp: async (newUser: User & Partial<MetaConversionPayload>) => {
    try {
      const res = await axios.post(`${baseURL}/api/auth/sign-up?lang=${getRequestLang()}`, newUser, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });

      return {
        status: "success",
        data: res.data,
      };
    } catch (error) {
      console.error(error);
      const { message } = error.response.data;
      return {
        status: "error",
        data: {
          message,
        },
      };
    }
  },


  // utils/api.ts

  googleSignUp: async (payload: {
  token: string;
  type: "worker" | "user";
} & Partial<MetaConversionPayload>) => {
  return backendCall({
    url: `/api/auth/google-signup`,
    method: "POST",
    data: payload,
    contentType: "application/json",
  })
    .then((res) => {
      if (res && res.success) {
        return {
          status: "success",
          data: res.data,
        };
      } else {
        throw new Error(
          res?.message ||
            (res?.data && res.data.message) ||
            "Google signup failed"
        );
      }
    })
    .catch((error) => ({
      status: "error",
      data: {
        message: error?.message || "Google signup failed",
      },
    }));
},

  googleSignIn: async (payload: {
    token: string;
  }) => {
    return backendCall({
      url: `/api/auth/google-sign-in`,
      method: "POST",
      data: payload,
      contentType: "application/json",
    })
      .then((res) => {
        if (res && res.success) {
          return {
            status: "success",
            data: res.data,
          };
        } else {
          throw new Error(
            res?.message ||
              (res?.data && res.data.message) ||
              "Google sign-in failed"
          );
        }
      })
      .catch((error) => ({
        status: "error",
        data: {
          message: error?.message || "Google sign-in failed",
        },
      }));
  },




  changePassword: async (passwordObj: {password: string, newPassword: string}) => {
    return backendCall({
      url: `/api/auth/change-password`,
      method: "POST",
      data: passwordObj,
      contentType: "application/json",
    }).then((res) => {
      if (res && res.success) {
        return res;
      } else {
        throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
      }
    })
    .catch((error) => error); 
  },

  resetPassword: async (newPasswordBody: unknown) => {

    const { data } = await axios.post(`${baseURL}/api/auth/reset-password?lang=${getRequestLang()}`, newPasswordBody, {
      headers: {
        "Content-Type": `application/json`,
      },
    });
    return data;

  },

  workerMarkedReched: async (id, latlng:{lat: number, long: number}) =>{
    return backendCall({
      url: `/api/applications/reached/${id}`,
      method: "POST",
      data: latlng,
      contentType: "application/json",
    }).then((res) => {
      if (res && res.success) {
        return res;
      } else {
        throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
      }
    })
  },


  getWorkerLocationFromJobApp: async (workerId: string, jobId: string) => {
  return backendCall({
    url: `/api/applications/location/${workerId}/${jobId}`,
    method: "GET",
    contentType: "application/json",
  })
    .then((res) => {
      if (res && res.success) {
        return res.data.location;
      } else {
        throw new Error(res?.message || "Unable to fetch location");
      }
    })
    .catch((err) => {
      console.error("Location API Error:", err);
      return null;
    });
}
,
  saveWorkerInitialLocation: async ({ jobId, workerId, location }) => {
  return backendCall({
    url: `/api/applications/location/${workerId}/${jobId}`,
    method: "POST",
    contentType: "application/json",
    data: {
    latitude: location.latitude,
    longitude: location.longitude
  },
  })
    .then((res) => {
      if (res && res.success) {
        return res;
      } else {
        throw new Error(
          res?.message || (res?.data && res.data.message) || "Unknown error"
        );
      }
    })
    .catch((error) => error);
},


  clientMarkedReched: async (id) =>{
    return backendCall({
      url: `/api/applications/reached-client/${id}`,
      method: "POST",
      contentType: "application/json",
    }).then((res) => {
      if (res && res.success) {
        return res;
      } else {
        throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
      }
    }).catch((error) => error);
  },

   workerMarkedOnMyWay: async (id) =>{
    return backendCall({
      url: `/api/applications/on-my-way/${id}`,
      method: "POST",
      contentType: "application/json",
    }).then((res) => {
      if (res && res.success) {
        return res;
      } else {
        throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
      }
    }).catch((error) => error);
  },

   saveFcmToken: async (body) =>{
    return backendCall({
      url: `/api/users/save-fcm-token`,
      method: "POST",
      data: body,
      contentType: "application/json",
    }).then((res) => {
          return res;
        }).catch((error) => error);
  },

  removeFcmToken: async (body) =>{
    return backendCall({
      url: `/api/users/remove-fcm-token`,
      method: "POST",
      data: body,
      contentType: "application/json",
    }).then((res) => {
          return res;
        }).catch((error) => error);
  },

  workerAcceptJob: async (id,body) =>{
    return backendCall({
      url: `/api/applications/status/${id}`,
      method: "POST",
      data: body,
      contentType: "application/json",
    }).then((res) => {
      if (res && res.success) {
        return res;
      } else {
        throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
      }
    })
  },


    clientAcceptJob: async (id,body) =>{
    return backendCall({
      url: `/api/applications/job-status/${id}`,
      method: "POST",
      data: body,
      contentType: "application/json",
    }).then((res) => {
      if (res && res.success) {
        return res;
      } else {
        throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
      }
    })
  },

getWorkerTransactions: async (workerId: string, filterValue: FilterI) => {
  return backendCall({
    url: `/api/stripe/worker-transactions/${workerId}?page=${filterValue.page}&limit=${filterValue.limit}`,
    method: "GET",
    contentType: "application/json",
  }).then((res) => {
    if (res && res.success) {
      return res;
    } else {
      throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
    }
  }).catch((error) => error);
},

getClientTransactions: async (clientId: string, filterValue: FilterI) => {
  return backendCall({
    url: `/api/stripe/customer-transactions/${clientId}?page=${filterValue.page}&limit=${filterValue.limit}`,
    method: "GET",
    contentType: "application/json",
  }).then((res) => {
    if (res && res.success) {
      return res;
    } else {
      throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
    }
  }).catch((error) => error);
},

  createJobForWorker: async (body) => {
    return backendCall({
      url: "/api/job/worker",
      method: "POST",
      data: body,
      contentType: "application/json",
    }).then((res) => {
      if (res && res.success) {
        return res;
      }
      return {
        success: false,
        message: getBackendCallErrorMessage(res),
        data: res?.data,
      };
    }).catch((error) => ({
      success: false,
      message: getBackendCallErrorMessage(
        error?.response?.data
          ? { data: error.response.data as Record<string, unknown> }
          : { message: error?.message }
      ),
      data: error?.response?.data,
    }));

  },

  // Multi-provider request quote create (createTask path).
  // Do NOT use createJobForWorker — no workerId / assignedWorker before accept.
  createRequestQuoteJob: async (body: Record<string, any>) => {
    const {
      workerId: _workerId,
      assignedWorker: _assignedWorker,
      ...safeBody
    } = body || {};

    return backendCall({
      url: "/api/job",
      method: "POST",
      data: {
        ...safeBody,
        isDirectHire: false,
        isProposalSent: false,
      },
      contentType: "application/json",
    })
      .then((res) => {
        if (res && res.success) {
          return res;
        }
        return {
          success: false,
          message: getBackendCallErrorMessage(res),
          data: res?.data,
        };
      })
      .catch((error) => ({
        success: false,
        message: getBackendCallErrorMessage(
          error?.response?.data
            ? { data: error.response.data as Record<string, unknown> }
            : { message: error?.message }
        ),
        data: error?.response?.data,
      }));
  },
  
  updateJobProposalForWorker: async (jobId: string, body: any) => {
  return backendCall({
    url: `/api/job/worker/${jobId}/proposal`,
    method: "PUT",
    data: body,
    contentType: "application/json",
  })
    .then((res) => {
      if (res && res.success) {
        return res;
      }
      return {
        success: false,
        message: getBackendCallErrorMessage(res),
        data: res?.data,
      };
    })
    .catch((error) => ({
      success: false,
      message: getBackendCallErrorMessage(
        error?.response?.data
          ? { data: error.response.data as Record<string, unknown> }
          : { message: error?.message }
      ),
      data: error?.response?.data,
    }));
},

  previewProviderVoucher: async (params: {
    voucherCode: string;
    budget: number;
    jobId?: string;
  }): Promise<{
    success: boolean;
    message?: string;
    data?: ProviderVoucherPreview | null;
  }> => {
    const query = new URLSearchParams();
    query.set("voucherCode", params.voucherCode.trim());
    query.set("budget", String(params.budget));
    if (params.jobId) query.set("jobId", params.jobId);

    return backendCall({
      url: `/api/job/provider-voucher/preview?${query.toString()}`,
      method: "GET",
      data: {},
      contentType: "application/json",
    })
      .then((res) => {
        if (res && res.success) {
          const body = res.data;
          const preview =
            body?.data && typeof body.data === "object" && !Array.isArray(body.data)
              ? (body.data as ProviderVoucherPreview)
              : (body as ProviderVoucherPreview);
          return { success: true, data: preview };
        }
        return {
          success: false,
          message: getBackendCallErrorMessage(res),
          data: null,
        };
      })
      .catch((error) => ({
        success: false,
        message: getBackendCallErrorMessage(
          error?.response?.data
            ? { data: error.response.data as Record<string, unknown> }
            : { message: error?.message }
        ),
        data: null,
      }));
  },

  getMyVouchers: async (): Promise<{
    success: boolean;
    message?: string;
    data: MyVoucher[];
  }> => {
    return backendCall({
      url: "/api/vouchers/mine",
      method: "GET",
      data: {},
      contentType: "application/json",
    })
      .then((res) => {
        if (res && res.success) {
          const body = res.data;
          const list = Array.isArray(body?.data)
            ? body.data
            : Array.isArray(body)
              ? body
              : [];
          return { success: true, data: list as MyVoucher[] };
        }
        return {
          success: false,
          message: getBackendCallErrorMessage(res),
          data: [] as MyVoucher[],
        };
      })
      .catch((error) => ({
        success: false,
        message: getBackendCallErrorMessage(
          error?.response?.data
            ? { data: error.response.data as Record<string, unknown> }
            : { message: error?.message }
        ),
        data: [] as MyVoucher[],
      }));
  },

getProposalDetails: async (body) => {
  try {
    const res = await backendCall({
      url: "/api/job/uid",
      method: "POST",
      data: body,
      contentType: "application/json",
    });

    return res;

  } catch (error: any) {
    console.log("Frontend caught error:", error);

    // Axios-style error handling
    const backendMessage =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      "Something went wrong";

    const statusCode = error?.response?.status;

    return {
      success: false,
      statusCode,
      message: backendMessage,
    };
  }
},


  isJobExist: async(userId,workerId)=>{
     return backendCall({
      url: `/api/job/jobexist`,
      method: "POST",
      data: { userId,workerId},
      contentType: "application/json",
    }).then((res) => {
      if (res && res.success) {
        return res;
      } else {
        throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
      }
    }).catch((error) => error);

  },

  sendMessageToWorker: async (
    workerId: string,
    message: string,
    type?: string,
    imageUrls?: string[]
  ) => {
    return backendCall({
      url: `/api/chats`,
      method: "POST",
      data: {
        recipient: workerId,
        message,
        type,
        ...(imageUrls?.length ? { imageUrls } : {}),
      },
      contentType: "application/json",
    }).then((res) => {
      if (res && res.success) {
        return res;
      } else {
        throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
      }
    }).catch((error) => error);
  },

  // Sends a request quote to one or more providers.
  // If `providerIds` is omitted/empty, backend auto-discovers nearest matching providers.
  sendRequestQuote: async (body: {
    jobId: string;
    message: string;
    imageUrls?: string[];
    providerIds?: string[];
    maxDistance?: number;
  } & Partial<MetaConversionPayload>) => {
    return backendCall({
      url: `/api/job/send-request-quote`,
      method: "POST",
      data: {
        jobId: body.jobId,
        message: body.message,
        ...(body.imageUrls?.length ? { imageUrls: body.imageUrls } : {}),
        ...(body.providerIds?.length ? { providerIds: body.providerIds } : {}),
        ...(body.maxDistance != null ? { maxDistance: body.maxDistance } : {}),
        ...(body.eventId ? { eventId: body.eventId } : {}),
        ...(body.eventSourceUrl ? { eventSourceUrl: body.eventSourceUrl } : {}),
        ...(body.fbp ? { fbp: body.fbp } : {}),
        ...(body.fbc ? { fbc: body.fbc } : {}),
      },
      contentType: "application/json",
    }).catch((error) => error);
  },

  // Provider: create/update their proposal for a request-quote job
  createOrUpdateRequestQuoteProposal: async (
    requestQuoteJobId: string,
    body: Record<string, any>
  ) => {
    return backendCall({
      url: `/api/proposals/request-quotes/${requestQuoteJobId}`,
      method: "POST",
      data: body,
      contentType: "application/json",
    }).catch((error) => error);
  },

  // Client or provider: list proposals for a request-quote job
  getProposalsForRequestQuote: async (requestQuoteJobId: string) => {
    return backendCall({
      url: `/api/proposals/request-quotes/${requestQuoteJobId}`,
      method: "GET",
      contentType: "application/json",
    }).catch((error) => error);
  },

  // Client: accept one proposal (converts request-quote job into a real job)
  acceptRequestQuoteProposal: async (proposalId: string) => {
    return backendCall({
      url: `/api/proposals/${proposalId}/accept`,
      method: "POST",
      contentType: "application/json",
    }).catch((error) => error);
  },

  // Provider: list proposals they've submitted
  getMyProposals: async () => {
    return backendCall({
      url: `/api/proposals/my`,
      method: "GET",
      contentType: "application/json",
    }).catch((error) => error);
  },

  // Provider: request-quote inbox (quotes sent to this provider, including awaiting)
  getProviderRequestQuoteInbox: async (params?: {
    page?: number;
    limit?: number;
    status?:
      | "all"
      | "awaiting"
      | "submitted"
      | "accepted"
      | "rejected"
      | "converted";
  }) => {
    const page = params?.page ?? 1;
    const limit = params?.limit ?? 10;
    const status = params?.status ?? "all";
    return backendCall({
      url: `/api/job/request-quotes/inbox?page=${page}&limit=${limit}&status=${status}`,
      method: "GET",
      contentType: "application/json",
    }).catch((error) => error);
  },

  // Provider: single inbox item detail (Mongo _id or JOB-uid)
  getProviderRequestQuoteInboxDetail: async (requestQuoteJobId: string) => {
    return backendCall({
      url: `/api/job/request-quotes/inbox/${requestQuoteJobId}`,
      method: "GET",
      contentType: "application/json",
    }).catch((error) => error);
  },

  sendMessageToClient: async (
    clientId: string,
    message: string,
    imageUrls?: string[]
  ) => {
    return backendCall({
      url: `/api/chats`,
      method: "POST",
      data: {
        recipient: clientId,
        message,
        ...(imageUrls?.length ? { imageUrls } : {}),
      },
      contentType: "application/json",
    }).then((res) => {
      if (res && res.success) {
        return res;
      } else {
        throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
      }
    }).catch((error) => error);
  },

  getMe: async () => {
     const token = window.localStorage.getItem("token") || window.sessionStorage.getItem("token");

    try {
      const { data: user } = await axios.get(`${baseURL}/api/users/me?lang=${getRequestLang()}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return user;
    } catch (error) {
      toast.error(error.message);
    }
  },

  getProfileDetails: async () => {
    return backendCall({
      url: "/api/users/me",
      method: "GET",
      contentType: "application/json",
    }).then((res) => {
      if (res && res.success) {
        return res;
      } else {
        throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
      }
    }).catch((error) => error);
  },

  updateProfileDetails: async (userData: { first_name?: string; last_name?: string; isSmsSent?: boolean }) => {

    return backendCall({
      url: "/api/users/me",
      method: "PUT",
      data: userData,
      contentType: "application/json",
    }).then((res) => {
      if (res && res.success) {
        return res;
      } else {
        throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
      }
    }).catch((error) => error);

  
  },

  updateProfile: async (userData: User) => {
     const token = window.localStorage.getItem("token") || window.sessionStorage.getItem("token");
    try {
      await axios.put(`${baseURL}/api/users/me?lang=${getRequestLang()}`, userData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
     
    } catch (error) {
      toast.error(error.message);
    }
  },

updateAvatarPicture: async (avatarForm) => {
  //  const token = window.localStorage.getItem("token") || window.sessionStorage.getItem("token");

  return backendCall({
    url: `/api/users/me/avatar?lang=${getRequestLang()}`,
    method: "PUT",
    data: avatarForm,
    contentType: "multipart/form-data",
  })
  .then((res) => {
    if (res && res.success) {
      return res;
    } else {
      throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
    }
  })
  .catch((error) => error);
},

  updateAvatarPhoto: async (avatarForm) => {
     const token = window.localStorage.getItem("token") || window.sessionStorage.getItem("token");

    try {
      const { data: user } = await axios.put(
        `${baseURL}/api/users/me/avatar?lang=${getRequestLang()}`,
        avatarForm,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Avatar actualizado con éxito");

      return user;
    } catch (error) {
      toast.error(error.message);
    }
  },

  updateJobPhoto: async (avatarForm) => {
    return backendCall({
      url: "/api/job/image",
      method: "POST",
      data: avatarForm,
      contentType: "multipart/form-data",
    }).then((res) => {
      if (res && res.success) {
        return res;
      }
      throw new Error(
        res?.message || (res?.data && res.data.message) || "Unknown error"
      );
    });
  },

  createCategory: async(id: string,services:string[]) =>{
   return backendCall({
      url: "/api/service-categories",
      method: "POST",
      data: {id , services},
      contentType: "application/json",
    })
      .then((res) => {
        if (res && res.success) {
          return res;
        } else {
          throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
        }
      })
      .catch((error) => error);
  }
,
  createService: async (name: string,skills:[],isUserCreated:boolean = false, mlname={}) => {

    return backendCall({
      url: "/api/services",
      method: "POST",
      data: {name , skills,isUserCreated,mlname},
      contentType: "application/json",
    })
      .then((res) => {
        if (res && res.success) {
          return res.data;
        } else {
          throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
        }
      })
      .catch((error) => error);
  },

  createSetupIntent: async (stripeId: {stripeId: string}) => {

    return backendCall({
      url: "/api/stripe/create-setup",
      method: "POST",
      data: stripeId,
      contentType: "application/json",
    })
      .then((res) => {
        if (res && res.success) {
          return res;
        } else {
          throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
        }
      })
      .catch((error) => error);
    },

    attachJobPaymentMethod: async (jobId: string, p_mthdId: {paymentMethodId: string}) => {

      return backendCall({
        url: `/api/job/paymentmethod/${jobId}`,
        method: "POST",
        data: p_mthdId,
        contentType: "application/json",
      })
        .then((res) => {
          if (res && res.success) {
            return res;
          } else {
            throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
          }
        })
        .catch((error) => error);
      },

      getJobPaymentDetails: async (jobId: string, voucherCode?: string) => {
        const query = voucherCode ? `?voucherCode=${encodeURIComponent(voucherCode)}` : '';

        return backendCall({
          url: `/api/job/payment/${jobId}${query}`,
          method: "GET",
          data: {},
          contentType: "application/json",
        })
          .then((res) => {
            if (res && res.success) {
              return res;
            }
            return {
              success: false,
              message: getBackendCallErrorMessage(res),
              data: res?.data,
            };
          })
          .catch((error) => ({
            success: false,
            message: getBackendCallErrorMessage(
              error?.response?.data
                ? { data: error.response.data as Record<string, unknown> }
                : { message: error?.message }
            ),
            data: error?.response?.data,
          }));
        },

        validateAthMovilUser: async (phoneNumber: string) => {
          return backendCall({
            url: `/api/ath-movil/validate-user`,
            method: "POST",
            data: { phoneNumber },
            contentType: "application/json",
          })
            .then((res) => {
              if (res && res.success) {
                return res;
              }
              return {
                success: false,
                message: getBackendCallErrorMessage(res),
                data: res?.data,
              };
            })
            .catch((error) => ({
              success: false,
              message: getBackendCallErrorMessage(
                error?.response?.data
                  ? { data: error.response.data as Record<string, unknown> }
                  : { message: error?.message }
              ),
            }));
        },

        initiateJobPayment: async (
          jobId: string,
          payload: InitiateJobPaymentPayload
        ): Promise<InitiateJobPaymentResponse> => {
          const { clientPaymentMethod, totalCharge, phoneNumber, voucherCode } = payload;
          return backendCall({
            url: `/api/applications/initiate-payment/${jobId}`,
            method: "POST",
            data: {
              totalCharge,
              paymentType: clientPaymentMethod,
              ...(phoneNumber ? { phoneNumber } : {}),
              ...(voucherCode ? { voucherCode } : {}),
            },
            contentType: "application/json",
          })
            .then((res) => {
              if (res && res.success) {
                return res as InitiateJobPaymentResponse;
              }
              return {
                success: false,
                message: getBackendCallErrorMessage(res),
                data: res?.data,
              } as InitiateJobPaymentResponse;
            })
            .catch((error) => ({
              success: false,
              message: getBackendCallErrorMessage(
                error?.response?.data
                  ? { data: error.response.data as Record<string, unknown> }
                  : { message: error?.message }
              ),
            }));
          },

          startJob: async (jobId: string) => {

            return backendCall({
              url: `/api/applications/start/${jobId}`,
              method: "POST",
              data: {},
              contentType: "application/json",
            })
              .then((res) => {
                if (res && res.success) {
                  return res;
                } else {
                  throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
                }
              })
              .catch((error) => error);
            },

            finishJob: async (jobId: string) => {
              return backendCall({
                url: `/api/applications/finish/${jobId}`,
                method: "POST",
                data: {},
                contentType: "application/json",
              })
                .then((res) => {
                  if (res && res.success) {
                    return res;
                  } else {
                    throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
                  }
                })
                .catch((error) => error);
              },
// 
              refundPayment: async (jobId: string, userId: string) => {
                return backendCall({
                  url: `/api/applications/cancel`,
                  method: "POST",
                  data: {jobId, userId},
                  contentType: "application/json",
                })
                  .then((res) => {
                    if (res && res.success) {
                      return res;
                    } else {
                      throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
                    }
                  })
                  .catch((error) => error);
                },

              releasePayment: async (jobId: string): Promise<ReleasePaymentResponse> => {
                return backendCall({
                  url: `/api/applications/complete/${jobId}`,
                  method: "POST",
                  data: {},
                  contentType: "application/json",
                })
                  .then((res) => {
                    if (res && res.success) {
                      return res as ReleasePaymentResponse;
                    }
                    throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
                  })
                  .catch((error) => error);
                },
              

                //worker jobs statuses

                getApplicationByJobId: async (jobId: string) => {

                  return backendCall({
                    url: `/api/applications/job/${jobId}`,
                    method: "GET",
                    data: {},
                    contentType: "application/json",
                  })
                    .then((res) => {
                      if (res && res.success) {
                        return res;
                      } else {
                        throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
                      }
                    })
                    .catch((error) => error);
                  },

                acceptJob: async (jobId: string) => {
                  return backendCall({
                    url: `/api/applications/status/${jobId}`,
                    method: "POST",
                    data: {status:"accepted"},
                    contentType: "application/json",
                  })
                    .then((res) => {
                      if (res && res.success) {
                        return res;
                      } else {
                        throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
                      }
                    })
                    .catch((error) => error);
                  },

                  rateWorker: async (data:{jobId:string,workerId: string, rating:number, review:string}) => {
                    return backendCall({
                      url: `/api/applications/review`,
                      method: "PUT",
                      data: data,
                      contentType: "application/json",
                    })
                    .then((res) => {
                      if (res && res.success) {
                        return res;
                      } else {
                        throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
                      }
                    })
                    .catch((error) => error);
                  },

                  getAllWorkerReviews: async (workerId: string,page:number=1,limit:number=4) => {

                    return backendCall({
                      url: `/api/applications/allreview/${workerId}?page=${page}&limit=${limit}`,
                      method: "GET",
                      data: {},
                      contentType: "application/json",
                    })
                      .then((res) => {
                        if (res && res.success) {
                          return res;
                        } else {
                          throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
                        }
                      })
                      .catch((error) => error);
                    },  
      


                    updateLogoPicture: async (avatarForm) => {
                  
                      return backendCall({
                        url: "/api/workerProfile/me/logo",
                        method: "PUT",
                        data: avatarForm,
                        contentType: "multipart/form-data",
                      })
                      .then((res) => {
                        if (res && res.success) {
                          return res;
                        } else {
                          throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
                        }
                      })
                      .catch((error) => error);
                   
                    },

  updateLogoPhoto: async (avatarForm) => {
     const token = window.localStorage.getItem("token") || window.sessionStorage.getItem("token");
    try {
      const { data: user } = await axios.put(
        `${baseURL}/api/workerProfile/me/logo`,
        avatarForm,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Avatar actualizado con éxito");

      return user;
    } catch (error) {
      toast.error(error.message);
    }
  },
  createCertification: async (certificationForm) => {
    //  const token = window.localStorage.getItem("token") || window.sessionStorage.getItem("token");

    // console.log(certificationForm);
    await backendCall({
      url: "/api/certifications",
      method: "POST",
      data: certificationForm,
      contentType: "multipart/form-data",
    })
    .then((res) => {
      if (res && res.success) {
        return res;
      } else {
        throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
      }
    })
    .catch((error) => error);

    // try {
    //   const { data: user } = await axios.post(
    //     `${baseURL}/api/certifications`,
    //     certificationForm,
    //     {
    //       headers: {
    //         Authorization: `Bearer ${token}`,
    //       },
    //     }
    //   );

    //   toast.success("Certificación creada con éxito");

    //   return user;
    // } catch (error) {
    //   toast.error(error.message);
    // }
  },
  getCertificationsByWorkerId: async (userId) => {
    
    return backendCall({
      url: `/api/certifications/worker/${userId}`,
      method: "GET",
      data: {},
      contentType: "application/json",
    })
      .then((res) => {
        if (res && res.success) {
          return res;
        } else {
          throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
        }
      })
      .catch((error) => error);

  },
  deleteCertificationById: async (certificationId) => {
    //  const token = window.localStorage.getItem("token") || window.sessionStorage.getItem("token");

    await backendCall({
      url: `/api/certifications/${certificationId}`,
      method: "DELETE",
      contentType: "application/json",
    })
    .then((res) => {
      if (res && res.success) {
        return res;
      } else {
        throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
      }
    })
    .catch((error) => error);

    // try {
    //   await axios.delete(`${baseURL}/api/certifications/${certificationId}`, {
    //     headers: {
    //       Authorization: `Bearer ${token}`,
    //     },
    //   });

    //   toast.success("Certificación eliminada");
    // } catch (error) {
    //   toast.error(error.message);
    // }
  },
  getAllWorkers: async () => {
    //  const token = window.localStorage.getItem("token") || window.sessionStorage.getItem("token");

    // try {
    //   const res = await axios.get(`${baseURL}/api/workerProfile/all`, {
    //     headers: {
    //       Authorization: `Bearer ${token}`,
    //     },
    //   });

    //   if (res.status !== 200) {
    //     throw new Error("Something went wrong!");
    //   }

    //   return res.data;
    // } catch (e) {
    //   console.error(e.message);
    //   return [];
    // }

    return backendCall({
      url: "/api/workerProfile/all",
      method: "GET",
      data: {},
      contentType: "application/json",
    })
      .then((res) => {
        if (res && res.success) {
          return res.data;
        } else {
          throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
        }
      })
      .catch((error) => { throw error });

  },
  getMyWorkerProfile: async () => {


    return backendCall({
      url: "/api/workerProfile/me",
      method: "GET",
      data: {},
      contentType: "application/json",
    })
      .then((res) => {
        if (res && res.success) {
          return res.data as WorkerProfile;
        } else {
          throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
        }
      })
      .catch((error) => { throw error });
  },

  getAccountLink: async () => {

    return backendCall({
      url: "/api/stripe/account-link",
      method: "GET",
      data: {},
      contentType: "application/json",
    })
      .then((res) => {
        console.log(res)
        if (res && res.success) {
          return {
            status: "success",
            data: res,
          };
        } else {
          return {
            status: "error",
            data: {
              message: res?.message || (res?.data && res.data.message) || "Unknown error",
            },
          };
        }

      }).catch((error) => error);

    //  const token = window.localStorage.getItem("token") || window.sessionStorage.getItem("token");

    // try {
    //   const res = await axios.get(`${baseURL}/api/stripe/account-link`, {
    //     headers: {
    //       Authorization: `Bearer ${token}`,
    //     },
    //   });
    //   return res.data;
    // } catch (error) {
    //   console.error(error);
    // }
  },
  // getWorkerById: async (workerId: string) => {

  //   backendCall({
  //     url: `/api/workerProfile/${workerId}`,
  //     method: "GET",
  //     data: {},
  //     contentType: "application/json",
  //   })
  //   .then((res) => {
  //     if (res && res.success) {
  //       return res.data as WorkerProfile;
  //     } else {
  //       throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
  //     }
  //   })
  //   .catch((error) => { throw error });



  // },

  getWorkerById: async (workerId: string) => {

    return backendCall({
      url: `/api/workerProfile/${workerId}`,
      method: "GET",
      contentType: "application/json",
    })
      .then((res) => {
        console.log("res", res)
        if (res && res.success) {
          return res.data as WorkerProfile;
        } else {
          throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
        }
      }).catch((error) => { throw error });

  },

  getUserById: async (userId: string) => {

    return backendCall({
      url: `/api/users/${userId}`,
      method: "GET",
      contentType: "application/json",
    })
      .then((res) => {
        console.log("res", res)
        if (res && res.success) {
          return res.data;
        } else {
          throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
        }
      }).catch((error) => { throw error });

  },


  getFilterWorker: async ({ text }: { text: string }) => {
     const token = window.localStorage.getItem("token") || window.sessionStorage.getItem("token");
    const body: { text: string } = { text };

    try {
      const res = await axios.post(
        `${baseURL}/api/workerProfile/filter?lang=${getRequestLang()}`,
        body,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = res.data;

      if (res.status !== 200) {
        throw new Error(data.message);
      }

      return data;
    } catch (e) {
      console.error(e.message);
      return [];
    }
  },


  getServiceByName: async (name: string) => {
  return backendCall({
    url: `/api/services/byname/${name}`,
    method: "GET",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.success) {
        // ✅ return the actual backend response payload
        return res.data; // this contains your service object
      } else {
        // ❌ backendCall caught an error
        throw new Error(
          res?.message ||
            (res?.data && res.data.message) ||
            "Unknown error"
        );
      }
    })
    .catch((error) => {
      throw error;
    });
},

  
  getServicesForSettings: async () =>{
     return backendCall({
      url: `/api/services/settings`,
      method: "GET",
      contentType: "application/json",
    })
    .then((res) => {
      if (res.status !== 200) {
        return res.data;
      } else {
        throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
      }
    })
    .catch((error) => { throw error });
  },


   getServiceCategoriesForSettings: async () =>{
     return backendCall({
      url: `/api/service-categories/settings`,
      method: "GET",
      contentType: "application/json",
    })
    .then((res) => {
      if (res.status !== 200) {
        return res.data;
      } else {
        throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
      }
    })
    .catch((error) => { throw error });
  },


  getServiceCategoriesForProposal: async (workerProfileId:string,workerid:string) =>{
     return backendCall({
      url: `/api/service-categories/send-proposal`,
      method: "POST",
      contentType: "application/json",
      data:{workerProfileId,workerid}
    })
    .then((res) => {
      if (res.status !== 200) {
        return res.data;
      } else {
        throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
      }
    })
    .catch((error) => { throw error });
  },
  getServices: async (): Promise<{ services: any[]; popular: any[] }> => {
    try {
      const res = await axios.get(`${baseURL}/api/services?lang=${getRequestLang()}`);
      if (res.status !== 200) {
        throw new Error(res.data);
      }
      const data = res.data;
      // New shape: { services, popular }
      if (data && !Array.isArray(data) && Array.isArray(data.services)) {
        return {
          services: data.services,
          popular: Array.isArray(data.popular) ? data.popular : [],
        };
      }
      // Legacy: bare services array
      if (Array.isArray(data)) {
        return { services: data, popular: [] };
      }
      return { services: [], popular: [] };
    } catch (e) {
      console.error({ message: e.message, stack: e.stack });
      return { services: [], popular: [] };
    }
  },
  getRegions: async () => {
    try {
      const res = await axios.get(`${baseURL}/api/region?lang=${getRequestLang()}`);
      if (res.status !== 200) {
        throw new Error(res.data);
      }
      return res.data;
    } catch (e) {
      console.error({ message: e.message, stack: e.stack });
      return [];
    }
  },
  getServiceCategories: async () => {
    try {
      const res = await axios.get(
        `${baseURL}/api/service-categories?lang=${getRequestLang()}`
      );
      if (res.status !== 200) {
        throw new Error(res.data);
      }
      return res.data;
    } catch (e) {
      console.error({ message: e.message, stack: e.stack });
      return [];
    }
  },
  getAllUserChats: async () => {
  const token = GetStorage()?.data?.token;
    try {
      const res = await axios.get(`${baseURL}/api/chats?lang=${getRequestLang()}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return res.data;
    } catch (error) {
      console.error(error);
      return [];
    }
  },
  getChatById: async (chatId: string) => {
    const token = GetStorage()?.data?.token;

    try {
      const res = await axios.get(`${baseURL}/api/chats/${chatId}?lang=${getRequestLang()}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return res.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  },

  getJobById: async (jobId: string) => {

    return backendCall({
      url: `/api/job/${jobId}`,
      method: "GET",
      contentType: "application/json",
    })
    .then((res) => {
      if (res && res.success) {
        return res;
      } else {
        throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
      }
    })
    .catch((error) => { throw error });

  },

  getChatByRecipient: async (recipient: string) => {
   const token = GetStorage()?.data?.token;

    try {
      const res = await axios.get(
        `${baseURL}/api/chats/recipient/${recipient}?lang=${getRequestLang()}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return res.data;
    } catch (error) {
      return null;
    }
  },

updateWorkerProfile: async (updateData) => {
  try {
    const res = await backendCall({
      url: "/api/workerProfile/me",
      method: "PUT",
      data: updateData,
      contentType: "application/json",
    });

    if (!res?.success) {
      return {
        success: false,
        message: getBackendCallErrorMessage(res),
        data: res?.data,
      };
    }

    const body = res.data;
    if (body && typeof body === "object" && body.success === false) {
      return {
        success: false,
        message: getBackendCallErrorMessage({
          message: typeof body.message === "string" ? body.message : undefined,
          data: body as Record<string, unknown>,
        }),
        data: body,
      };
    }

    return res;
  } catch (error: unknown) {
    const err = error as {
      message?: string;
      response?: { data?: Record<string, unknown> };
    };
    return {
      success: false,
      message: getBackendCallErrorMessage({
        data: err?.response?.data,
        message: err?.message,
      }),
    };
  }
},

  updateMyWorkerProfile: async (updateData) => {
     const token = window.localStorage.getItem("token") || window.sessionStorage.getItem("token");
    try {
      const res = await axios.put(
        `${baseURL}/api/workerProfile/me?lang=${getRequestLang()}`,
        updateData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (res.status !== 200) {
        throw new Error(res.data);
      }
    } catch (e) {
      console.error({ message: e.message, stack: e.stack });
    }
  },

  updateMyWorkerServices: async (updateData) => {

    return backendCall({
      url: "/api/workerProfile/me",
      method: "PUT",
      data: updateData,
      contentType: "application/json",
    })
    .then((res) => {
      if (res && res.success) {
        return res;
      } else {
        throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
      }
    })
    .catch((error) => { throw error });
  
  },
  sendChatMessage: async ({
    message,
    recipientId,
  }: {
    message: string;
    recipientId: string;
  }) => {
     const token = window.localStorage.getItem("token") || window.sessionStorage.getItem("token");

    try {
      const res = await axios.post(
        `${baseURL}/api/chats?lang=${getRequestLang()}`,
        { message, recipient: recipientId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return {
        status: res.status,
        notification: "Mensaje enviado",
        chat: res.data,
      };
    } catch (error) {
      console.error(error);
      return {
        status: "error",
        notification: error.response.data.error,
        chat: null,
      };
    }
  },
  createQuote: async ({
    items,
    customerId,
    customId,
    dueDate,
  }: {
    items: { description: string; price: number }[];
    customerId: string;
    customId: string;
    dueDate: number;
  }) => {
     const token = window.localStorage.getItem("token") || window.sessionStorage.getItem("token");

    try {
      const res = await axios.post(
        `${baseURL}/api/quotes?lang=${getRequestLang()}`,
        { items, customerId, customId, dueDate: new Date(dueDate) },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return {
        status: res.status,
        notification: "Quote creado y enviado",
        chat: res.data.chat,
      };
    } catch (error) {
      console.error(error);
      return {
        status: "error",
        notification: error.response.data.error,
        chat: null,
      };
    }
  },
  getAllWorkersThatSentQuotes: async () => {
     const token = window.localStorage.getItem("token") || window.sessionStorage.getItem("token");

    try {
      const res = await axios.get(`${baseURL}/api/quotes/workers?lang=${getRequestLang()}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        status: res.status,
        notification: "Quotes obtenidas",
        workersData: res.data.workers,
      };
    } catch (error) {
      console.error(error);
      return {
        status: "error",
        notification: error.response.data.error,
        workersData: null,
      };
    }
  },
  getQuotesBySupplierId: async (supplierId) => {
     const token = window.localStorage.getItem("token") || window.sessionStorage.getItem("token");

    try {
      const res = await axios.get(
        `${baseURL}/api/quotes/workers/${supplierId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return {
        status: res.status,
        notification: "Quote obtenida",
        quotesData: res.data,
      };
    } catch (error) {
      console.error(error);
      return {
        status: "error",
        notification: error.response.data.error,
        quotesData: null,
      };
    }
  },
  getAllInvoicesBySupplierId: async (supplierId) => {
     const token = window.localStorage.getItem("token") || window.sessionStorage.getItem("token");

    try {
      const res = await axios.get(`${baseURL}/api/invoice/all/${supplierId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        status: res.status,
        notification: "Quote obtenida",
        invoicesData: res.data,
      };
    } catch (error) {
      console.error(error);
      return {
        status: "error",
        notification: error.response.data.error,
        quotesData: null,
      };
    }
  },
  updateInvoice: async (invoiceId, invoiceDTO) => {
     const token = window.localStorage.getItem("token") || window.sessionStorage.getItem("token");

    try {
      const { data } = await axios.put(
        `${baseURL}/api/invoice/${invoiceId}`,
        { invoiceDTO },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return data;
    } catch (error) {
      toast.error("Error en la API");
    }
  },
  getQuoteById: async ({ quoteId }: { quoteId: string }) => {
     const token = window.localStorage.getItem("token") || window.sessionStorage.getItem("token");

    try {
      const res = await axios.get(`${baseURL}/api/quotes/${quoteId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return {
        status: res.status,
        notification: "Quote obtenida",
        quoteData: res.data,
      };
    } catch (error) {
      console.error(error);
      return {
        status: "error",
        notification: error.response.data.error,
        quoteData: null,
      };
    }
  },
  acceptQuote: async ({ quoteId }) => {
     const token = window.localStorage.getItem("token") || window.sessionStorage.getItem("token");
    try {
      const res = await axios.post(
        `${baseURL}/api/quotes/${quoteId}/accept`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return {
        status: res.status,
        notification: res.data.notification,
      };
    } catch (error) {
      console.error(error);
      return {
        status: "error",
        notification: error.response.data.message,
      };
    }
  },
  rejectQuote: async ({ quoteId }) => {
     const token = window.localStorage.getItem("token") || window.sessionStorage.getItem("token");

    try {
      const res = await axios.post(
        `${baseURL}/api/quotes/${quoteId}/reject`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return {
        status: res.status,
        notification: res.data.notification,
      };
    } catch (error) {
      console.error(error);
      return {
        status: "error",
        notification: error.response.data.message,
      };
    }
  },
  updateQuote: async ({ quoteId, quoteDTO }) => {
    const token = window.localStorage.getItem("token") || window.sessionStorage.getItem("token");

    try {
      const res = await axios.put(
        `${baseURL}/api/quotes/${quoteId}`,
        quoteDTO,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return res.data;
    } catch (error) {
      console.error(error);
    }
  },
  getAccount: async () => {
     const token = window.localStorage.getItem("token") || window.sessionStorage.getItem("token");

    try {
      const res = await axios.get(`${baseURL}/api/stripe/account`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return res.data;
    } catch (error) {
      console.error(error);
    }
  },
  getAccountById: async (id: string) => {
     const token = window.localStorage.getItem("token") || window.sessionStorage.getItem("token");

    try {
      const res = await axios.get(`${baseURL}/api/stripe/account/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return res.data;
    } catch (error) {
      console.error(error);
    }
  },

  getDashboardLink: async () => {
     const token = window.localStorage.getItem("token") || window.sessionStorage.getItem("token");

    try {
      const res = await axios.get(`${baseURL}/api/stripe/dashboard-link`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return res.data;
    } catch (error) {
      console.error(error);
    }
  },

  getStripeDashboardLink: async ()=>{
    return backendCall({
      url: `/api/stripe/dashboard-link`,
      method: "GET",
      contentType: "application/json",
    })
    .then((res) => {
      console.log("dashboard rspnse",res)
      if (res.success) {
        return res.data.data;
      } else {
        throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
      }
    })
    .catch((error) => { throw error });
  },
  createCheckout: async (
    items: { description: string; price: number; quantity: number }[],
    workerAccountId: string
  ) => {
     const token = window.localStorage.getItem("token") || window.sessionStorage.getItem("token");

    try {
      const { data } = await axios.post(
        `${baseURL}/api/stripe/create-checkout`,
        { items, workerAccountId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return data;
    } catch (error) {
      toast.error("Error en la API de Stripe");
    }
  },
  getCheckout: async (checkoutId) => {
     const token = window.localStorage.getItem("token") || window.sessionStorage.getItem("token");

    try {
      const { data } = await axios.post(
        `${baseURL}/api/stripe/retrieve-checkout`,
        { checkoutId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return data;
    } catch (error) {
      toast.error("Error en la API de Stripe");
    }
  },
  captureFounds: async (paymentIntentId: string) => {
     const token = window.localStorage.getItem("token") || window.sessionStorage.getItem("token");
    try {
      const { data } = await axios.post(
        `${baseURL}/api/stripe/capture-founds`,
        { paymentIntentId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success("Pago efectuado correctamente.");
      return data;
    } catch (error) {
      toast.error(error.message);
    }
  },

  forgotPassword: async (body) => {
    // eslint-disable-next-line no-useless-catch
    try {
      const res = await axios.post(`${baseURL}/api/auth/forgot-password`, body);
      if (res.status !== 200) {
        throw new Error(res.data.message);
      }
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  forgotPasswordByPhone: async (body) => {
    // eslint-disable-next-line no-useless-catch
    try {
      const res = await axios.post(`${baseURL}/api/auth/verify-otp`, body);
      if (res.status !== 200) {
        throw new Error(res.data.message);
      }
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  verifyEmail: async (body: { code: string; email: string }) => {
    try {
      const res = await axios.post(`${baseURL}/api/auth/verify-email`, body, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return {
        status: "success",
        data: res.data,
      };
    } catch (error) {
      const { message } = error.response.data;
      return {
        status: "error",
        data: {
          message,
        },
      };
    }
  },

  verifyEmailLink: async (body: { code: string; email: string }) => {
    try {
      const res = await axios.post(`${baseURL}/api/auth/email-verification`, body, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return {
        status: "success",
        data: res.data,
      };
    } catch (error) {
      const { message } = error.response.data;
      return {
        status: "error",
        data: {
          message,
        },
      };
    }
  },
  getFilterWorkersList: async (filter: any) => {
    //  const token = window.localStorage.getItem("token") || window.sessionStorage.getItem("token");

    return backendCall({
      url: `/api/workerProfile/filter?page=${filter.page}&limit=${filter.limit}`,
      method: "POST",
      data: filter,
      contentType: "application/json",
    })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.error(err);
      return {
        data: [],
        totalPages: 0,
        totalItems: 0,
      };
    });
  
       
    // try {
    //   const res = await axios.post(
    //     `${baseURL}/api/workerProfile/filter?page=${filter.page}&limit=${filter.limit}`,
    //     filter,
    //     {
    //       headers: {
    //         Authorization: token ? `Bearer ${token}` : undefined,
    //         "Content-Type": "application/json",
    //       },
    //     }
    //   );
    //   if (res.status !== 200) {
    //     throw new Error(res.data?.message || 'Error fetching filtered workers');
    //   }
    //   return res.data;
    // } catch (e) {
    //   console.error(e.message);
    //   return [];
    // }
  },

  // Dispute API functions
  createDispute: async (data: { jobId: string; issueType: string; description: string; imageUrls?: string[]; createdBy?: string }) => {
    console.log("data", data)
    return backendCall({
      url: "/api/disputes",
      method: "POST",
      data,
      contentType: "application/json",
    })
      .then((res) => {
        if (res && res.success) {
          return res;
        } else {
          throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
        }
      })
      .catch((error) => {
        throw error;
      });
  },

  getDisputes: async (filters?: { status?: string; jobId?: string; page?: number; limit?: number }) => {
    const queryParams = new URLSearchParams();
    if (filters?.status) queryParams.append('status', filters.status);
    if (filters?.jobId) queryParams.append('jobId', filters.jobId);
    if (filters?.page) queryParams.append('page', filters.page.toString());
    if (filters?.limit) queryParams.append('limit', filters.limit.toString());

    const queryString = queryParams.toString();
    const url = `/api/disputes${queryString ? `?${queryString}` : ''}`;

    return backendCall({
      url,
      method: "GET",
      contentType: "application/json",
    })
      .then((res) => {
        if (res && res.success) {
          return res;
        } else {
          throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
        }
      })
      .catch((error) => {
        throw error;
      });
  },

  getDisputeById: async (id: string) => {
    return backendCall({
      url: `/api/disputes/${id}`,
      method: "GET",
      contentType: "application/json",
    })
      .then((res) => {
        if (res && res.success) {
          return res;
        } else {
          throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
        }
      })
      .catch((error) => {
        throw error;
      });
  },

  updateDisputeStatus: async (id: string, data: { status: string; resolutionNotes?: string }) => {
    return backendCall({
      url: `/api/admin/disputes/${id}/status`,
      method: "PATCH",
      data,
      contentType: "application/json",
    })
      .then((res) => {
        if (res && res.success) {
          return res;
        } else {
          throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
        }
      })
      .catch((error) => {
        throw error;
      });
  },

  getAdminDisputes: async (filters?: { status?: string; jobId?: string; page?: number; limit?: number }) => {
    const queryParams = new URLSearchParams();
    if (filters?.status) queryParams.append('status', filters.status);
    if (filters?.jobId) queryParams.append('jobId', filters.jobId);
    if (filters?.page) queryParams.append('page', filters.page.toString());
    if (filters?.limit) queryParams.append('limit', filters.limit.toString());

    const queryString = queryParams.toString();
    const url = `/api/admin/disputes${queryString ? `?${queryString}` : ''}`;

    return backendCall({
      url,
      method: "GET",
      contentType: "application/json",
    })
      .then((res) => {
        if (res && res.success) {
          return res;
        } else {
          throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
        }
      })
      .catch((error) => {
        throw error;
      });
  },

  getAdminDisputeById: async (id: string) => {
    return backendCall({
      url: `/api/admin/disputes/${id}`,
      method: "GET",
      contentType: "application/json",
    })
      .then((res) => {
        if (res && res.success) {
          return res;
        } else {
          throw new Error(res?.message || (res?.data && res.data.message) || "Unknown error");
        }
      })
      .catch((error) => {
        throw error;
      });
  },

  /** Natural-language home search → service/region interpretation */
  interpretSearch: async (payload: {
    query: string;
    limit?: number;
    lang?: string;
  }) => {
    return backendCall({
      url: "/api/search/interpret",
      method: "POST",
      data: {
        query: payload.query,
        limit: payload.limit ?? 5,
        lang: payload.lang || "es",
      },
      contentType: "application/json",
      isShowErrorMessage: false,
    })
      .then((res) => {
        if (res?.success) return res.data;
        return null;
      })
      .catch((err) => {
        console.error("interpretSearch failed:", err);
        return null;
      });
  },
};
